
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/monthly-market",
      function () {
        return require("private-next-pages/monthly-market/index.tsx");
      }
    ]);
  